<template>
  <template v-if="defaultBorder">
    <div
      ref="overlay"
      :style="{
        width: windowWidth / scale + 'px',
        height: windowHeight*3 / scale + 'px',
      }"
      class="overlay"
      :class="{ hidden1: !showOverlay, visible1: showOverlay }"
    ></div>
    <div class="default-border"></div>
    <t-checkbox
      class="my_checkbox_item"
      :style="setStyles"
      v-model="isChecked"
      v-show="isCheckShow"
    ></t-checkbox>
  </template>
  <template v-else>
    <div
      ref="overlay"
      @click="clickOverlay"
      :style="{
        width: windowWidth / scale + 'px',
        height: windowHeight*3 / scale + 'px',
        backgroundColor: option.attribute.overlayColor,
      }"
      class="overlay"
      :class="{ hidden1: !showOverlay, visible1: showOverlay }"
    ></div>
    <t-checkbox
      class="my_checkbox_item"
      :style="setStyles"
      v-model="isChecked"
      v-show="isCheckShow"
    ></t-checkbox>
    <div class="nineigrid-border" :style="{ border: borderColor3 ? `${borderWidth}px solid ` + borderColor3 : '', width: width - (borderWidth * 2) + 'px', height: height - (borderWidth * 2) + 'px' }"  @click="clickHandler">
      <div v-if="isSelf"  class="self-border"
      :style="{ 
         width: width-6 + 'px',
         height: height-6 + 'px',
         borderRadius: selfBorderRadius + 'px',
         backgroundColor: selfBgColor,
         borderColor:selfBorderColor,
         borderWidth: selfBorderSize + 'px',
         }"
      >
      </div>
      <div v-if="!isSelf">
        <component
          :is="option.attribute.borderType"
          :style="{ width: width + 'px', height: height + 'px' }"
          style="overflow: hidden"
          :color="[option.attribute.borderColor1, option.attribute.borderColor2]"
          :backgroundColor="option.attribute.backgroundColor"
          :title="option.attribute.borderTitle"
          :titleWidth="option.attribute.titleWidth"
          :dur="option.attribute.dur"
          :reverse="option.attribute.reverse"
          @click="clickHandler"
        />
      </div>
      
    </div>
    <!--  默认宽高为100%（http://datav.jiaminghi.com/guide/borderBox.html），会出现滚动条常驻现象 -->
  </template>
</template>

<script>
import cptTextOption from "@/components/dataV/attrs/cpt-dataV-border-option";
export default {
  name: "cpt-dataV-border",
  props: {
    width: Number,
    height: Number,
    scale: Number,
    option: Object,
    current: Object,
    refMap: Object,
    scrollStr: String,
    // 父组件传递了下面这些属性，但是该组件有多个根节点，Vue 不确定应该在哪个根节点上继承这些属性，然后控制台就出现了警告信息，故显式添加这些属性，以消除控制台警告
    elementId: String,
    cacheComponents: Array,
    show: Boolean,
    design: Boolean,
    drop: Function,
    cacheChoices: Object,
    componentLevel: Number,
  },
  data() {
    return {
      isChecked: false,
      isCheckShow: false,
      showOverlay: false,
      borderColor3: "",
      borderWidth: 0,
      windowWidth: window.innerWidth * 2,
      windowHeight: window.innerHeight * 2,
    };
  },
  // beforeCreate(){
  //   const temp = JSON.parse(JSON.stringify(cptTextOption.attribute))
  //   this.option.attribute = Object.assign({}, temp, this.option.attribute);
  // },
  computed: {
    isSelf(){
      return this.option.attribute.isSelfBorder || false
    },
    selfBorderColor(){
      return this.option.attribute.selfBorderColor || 'rgba(0, 0, 0, 0.5)'
    },
    selfBorderRadius(){
      return this.option.attribute.selfBorderRadius || 0
    },
    selfBorderSize(){
      return this.option.attribute.selfBorderSize || 1
    },
    selfBgColor(){
      return this.option.attribute.selfBgColor || 'rgba(0, 0, 0, 0.5)'
    },
    defaultBorder() {
      let isDefault =
        (this.current.cptType === "ngcombination-border" ||
          this.current.cptType === "combination-border" ||
          this.current.cptType === "ngcombination-border-top" ||
          this.current.cptType === "ngcombination-border-bottom" ||
          this.current.cptType === "cpt-suspension") &&
        this.option.attribute.borderType === "dv-border-box-0";
      // 是否是编辑模式
      let isDesign = location.href.includes("/design");
      return isDefault && isDesign;
    },
    setStyles() {
      return {
        "--bgColor": this.option.attribute.bgColor,
        "--brColor": this.option.attribute.brColor,
        "--activeBgColor": this.option.attribute.activeBgColor,
        "--activeBrColor": this.option.attribute.activeBrColor,
        "--activeBg": this.option.attribute.activeBg,
        "--top": this.option.attribute.top + "px",
        "--left": this.option.attribute.left + "px",
        "--borderRadius": this.option.attribute.borderRadius + "px",
      };
    },
  },
  mounted() {
    let isDesign = location.href.includes("/design");
    if (!isDesign) {
      this.$nextTick(()=>{
        document.querySelector("#scaleDiv") ? this.windowHeight = document.querySelector("#scaleDiv")?.clientHeight : null;
      })
      
    }
    if (!this.option.attribute.selfBgColer) {
      this.option.attribute.selfBorderColor = 'rgba(0, 0, 0, 0.5)';
      this.option.attribute.selfBorderRadius = 0;
      this.option.attribute.selfBorderSize = 1;
      this.option.attribute.isSelfBorder = false;
      this.option.attribute.selfBgColer = 'rgba(0, 0, 0, 0.5)';
    }

    if (this.current.group) {
      this.current.group.forEach((gid) => {
        // console.log(this.option.attribute.switchGrid,'this.refMap[gid]')
        if (
          this.refMap[gid] &&
          this.refMap[gid].current &&
          this.refMap[gid].current.cptType == "ngcombination"
        ) {
          this.refMap[gid].onChange(this.option.attribute.switchGrid);
        }
      });

      if (this.current.id == "11864460-f961-11ee-9e8e-d343169bc989") {
        console.log("hjhjhj");
        setTimeout(() => {
          this.clickHandler();
        }, 2000);
        // this.clickHandler()
      }
    }
  },
  methods: {
    processData() {
      return false;
    },
    clickOverlay() {
      if (this.option.attribute.isCloseOther) {
        this.clickClose();
      }
    },
    clickClose() {
      // console.log(this.current)
      document.getElementById("notParentScaleDiv").style.display = "block";
      this.current.group.forEach((gid) => {
        if (
          this.refMap[gid].current &&
          this.refMap[gid].current.cptType == "ngcombination"
        ) {
          this.refMap[gid].hidePop();
          this.childIsOverlay();
        }
      });
    },
    //显示隐藏遮罩层
    childIsOverlay() {
      // debugger

      this.showOverlay = !this.showOverlay;
      let flag = this.showOverlay;
      this.$nextTick(() => {
        const modal = this.$refs.overlay;
        // modal.addEventListener("scroll", this.preventScroll, {
        //   passive: false,
        // });
        if (!flag) {
          // 恢复背景页面滚动
          // modal.removeEventListener("scroll", this.preventScroll);
          modal.parentNode.parentNode.parentNode.parentNode.style.overflow =
            "hidden auto";
        }
      });
    },
    // 阻止滚动事件的默认行为
    preventScroll(event) {
      event.preventDefault();
    },
    //显示复选框
    showCheck() {
      this.isCheckShow = true;
    },
    //勾选复选框
    clickCheck() {
      this.isChecked = true;
    },
    //取消勾选复选框
    clickCheckFalse() {
      this.isCheckShow = false;
    },
    clickHandler() {
      // this.$emit("clickHandler", this.option.interaction)
      console.log("asdasdasdasdasdasd");
  
      if (this.current.group) {
        this.current.group.forEach((gid) => {
          if (
            this.refMap[gid].current &&
            this.refMap[gid].current.cptType == "ngcombination"
          ) {
            this.refMap[gid].gocheck(this.current);
          }
        });
      }
      this.$emit(
        "clickHandler",
        this.option.interaction,
        "default",
        this.current.colData,
        "cpt-dataV-border"
      );
      
    },
  },
};
</script>

<style scoped>
.default-border {
  width: 100%;
  height: 100%;
  border: 2px dashed rgb(110, 110, 110);
}
.is-check {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10000001;
}
.bi-icon {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #a6a6a6;
  border-radius: 50%;
  padding: 3px 4px;
  font-size: 13px;
  padding-top: 0px;
  width: 1em;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  /* width: 100vw !important;
  height: 100vh !important; */
  pointer-events: auto;
  background-color: rgba(0, 0, 0, 0.5); /* 可以调整透明度 */
  display: flex;
  justify-content: center;
  align-items: center;
}

.hidden1 {
  display: none;
}

.visible1 {
  display: flex;
}

.my_checkbox_item {
  top: var(--top);
  left: var(--left);
}

.my_checkbox_item /deep/ .t-checkbox__input {
  background-color: var(--bgColor);
  border-color: var(--brColor) !important;
  border-radius: var(--borderRadius);
}

.my_checkbox_item.t-is-checked /deep/ .t-checkbox__input {
  background-color: var(--activeBgColor) !important;
  border-color: var(--activeBrColor) !important;
}

.my_checkbox_item /deep/ .t-checkbox__input::after {
  border-color: var(--activeBg) !important;
}
.self-border{
  border: red solid 1px;
}
</style>
